var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFbWave(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#fb-wave_svg__clip0_3932_27028)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.466 4.444H8.653a4.208 4.208 0 00-4.209 4.209v22.813a4.208 4.208 0 004.209 4.208h11.25l.02-11.16h-2.9a.684.684 0 01-.683-.681l-.014-3.597a.684.684 0 01.684-.687h2.894v-3.476c0-4.034 2.464-6.23 6.062-6.23h2.953c.377 0 .684.306.684.684v3.033a.684.684 0 01-.684.684l-1.812.001c-1.957 0-2.336.93-2.336 2.295v3.009h4.3c.41 0 .728.358.68.765l-.427 3.597a.684.684 0 01-.68.604H24.79l-.019 11.16h6.695a4.208 4.208 0 004.208-4.209V8.653a4.208 4.208 0 00-4.208-4.209z",
    fill: "url(#fb-wave_svg__paint0_linear_3932_27028)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.466 4.444H8.653a4.208 4.208 0 00-4.209 4.209v22.813a4.208 4.208 0 004.209 4.208h11.25l.02-11.16h-2.9a.684.684 0 01-.683-.681l-.014-3.597a.684.684 0 01.684-.687h2.894v-3.476c0-4.034 2.464-6.23 6.062-6.23h2.953c.377 0 .684.306.684.684v3.033a.684.684 0 01-.684.684l-1.812.001c-1.957 0-2.336.93-2.336 2.295v3.009h4.3c.41 0 .728.358.68.765l-.427 3.597a.684.684 0 01-.68.604H24.79l-.019 11.16h6.695a4.208 4.208 0 004.208-4.209V8.653a4.208 4.208 0 00-4.208-4.209z",
    fill: "url(#fb-wave_svg__paint1_linear_3932_27028)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 19.029,
    width: 24,
    height: 24,
    rx: 12,
    fill: "#2F54EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.863 30.881a.617.617 0 00-1.05-.438c-.13.127-2.374 2.364-2.57 2.56a.491.491 0 01-.693-.696l4.268-4.253a.612.612 0 00.002-.872l-.017-.017a.617.617 0 00-.87-.001c-.777.772-3.032 3.019-3.835 3.819a.491.491 0 01-.693-.696c1.226-1.223 2.91-2.899 4.133-4.117a.612.612 0 00.001-.872l-.02-.02a.612.612 0 00-.872 0L31.524 29.4a.491.491 0 01-.695-.695l3.384-3.383a.612.612 0 00.18-.435.612.612 0 00-.18-.436l-.014-.014a.616.616 0 00-.87.001l-5.506 5.505a.49.49 0 01-.825-.462l.942-3.889a.764.764 0 10-1.49-.35l-.072.319a19.795 19.795 0 01-1.797 4.789 5.128 5.128 0 00-.53 3.094 5.041 5.041 0 001.437 2.865 5.05 5.05 0 003.595 1.49h.004a5.05 5.05 0 003.596-1.495l1.224-1.227 3.776-3.762a.612.612 0 00.18-.435z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 19.029,
    width: 24,
    height: 24,
    rx: 12,
    stroke: "#fff",
    strokeWidth: 2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "fb-wave_svg__paint0_linear_3932_27028",
    x1: 36.297,
    y1: 4.731,
    x2: 4.737,
    y2: 36.297,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fb-wave_svg__paint1_linear_3932_27028",
    x1: 35.605,
    y1: 4.514,
    x2: 4.513,
    y2: 35.605,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.354,
    stopColor: "#4867AA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7295E1"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "fb-wave_svg__clip0_3932_27028"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h44v44H0z"
  })))));
}

export default __webpack_public_path__ + "./fonts/fb-wave.f711f80aed6471ca40eaf6559dd54aec.svg";
export { SvgFbWave as ReactComponent };